import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from "react-router-dom";
import Api from '../api/api';


class FAQ extends React.Component {

    state={
        data:''
    }

    componentDidMount(){
        document.title ="FAQ / Cerafini";

        Api.getFaq().then((response)=>{
            this.setState({data:response.data})
        })
    }

    createMarkup = (data) => {
        return {__html: data};
    }

    render (){
        const {data} = this.state;
        const {langTxt}=this.props;
        return(
            <div className="faq-page page">
            {(data)? 
                <>
                   <h1>FAQ</h1>
                   <span dangerouslySetInnerHTML= {this.createMarkup(data.faq["value_" + langTxt])} />
                </>
                : <></>}
                
            </div>
        );
    }
}


// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(FAQ) );

